<template>
  <slot>
    <div style="padding-top:1%;padding-bottom:1%;">
      <div v-if="message" class="announcement-banner-container">
        <p class="moving-text" aria-hidden="true">{{ message.trim() }}</p>
      </div>
    </div>
  </slot>
</template>

<script>
export default {
  name: 'AnnouncementBanner',
  props: ['dairyId'],
  data: function () {
    return {
      message: '',
      pollInterval: null,
    }
  },
  methods: {
    getAnnouncement() {
      this.axios
          .get('admin/announcement/get',
              {
                params: {
                  dairyId: this.dairyId
                }
              }
          )
          .then(response => {
            this.message = response.data.trim()
          })
          .catch(error => {
            this.setApiError(true)
            this.setApiErrorText(error.response.statusText)
          })
    },
    displayAnnouncement() {
      this.pollInterval = setInterval(() => {
        this.getAnnouncement()
      }, 1800000)
    }
  },
  beforeUnmount() {
    clearInterval(this.pollInterval)
  },
  created() {
    this.getAnnouncement()
    this.displayAnnouncement()
  },
}
</script>

<style scoped>
.announcement-banner-container {
  width: 60vw;
  font-weight: bold;
  background: #0dcaf0;
  margin: 0 auto;
  max-height: 425px;
  overflow-x: hidden !important;
  border-radius: 5px;
  white-space: nowrap;
}

.moving-text:hover {
  animation-play-state: paused;
}

@keyframes marquee {
  0% {
    transform: translateX(100vw);
  }
  100% {
    transform: translateX(-100vw);
  }
}

@media (prefers-reduced-motion: no-preference) {
  .moving-text {
    animation: marquee 20s linear infinite;
  }
}
</style>
